import {
  ADD_INDIVIDUAL_GROUPS,
  CHAT_CONVERSATION_FAILED,
  CHAT_CONVERSATION_GET,
  CHAT_CONVERSATION_LOAD_MORE,
  CHAT_CONVERSATION_PUSH_MESSAGE,
  CHAT_CONVERSATION_SUCCESS,
  CHAT_NEW_ROOM,
  CHAT_ROOMS_FAILED,
  CHAT_ROOMS_GET,
  CHAT_ROOMS_SUCCESS,
  DELETE_MESSAGE,
  GLOBAL_CHAT,
  SEARCH_CONVERSATIONS,
  UPDATE_MESSAGE,
  FATCH_USERS_TO_GROUP,
  ADD_GROUP,
  GROUP_INFO,
  SEARCH_CONVERSATION_GROUP,
  ADDUSER_TO_GROUP,
  USER_LEAVE_GROUP,
  ADMIN_ACCESS,
  REMOVE_GROUP_ADMIN,
  UPDATE_GROUP_INFO,
  DELETE_CONVERSATION,
  CHAT_WIDGET_USER_CREATE,
  ADD_GROUPS_CHAT_WIDGET,
  USER_LOGIN_WIDGET,
  CHAT_WIDGET_CONVERSATION,
  CHAT_WIDGET_CONVERSATION_PUSH_MESSAGE,
  ADD_USER_TO_GROUP_CHAT_WIDGET,
} from "../constants/type";
import moment from "moment";

const initialState = {
  chatRoomLoading: true,
  chatRooms: [],
  chatHistoryLoading: false,
  chatHistory: [],
  hasMoreMessages: true,
  searchConversationsResponse: {},
  addGroupsResponse: {},
  globalChatData: {},
  UpdateMessage: {},
  FetchUsersToGroup: {},
  AddGroups: {},
  GroupInfo: {},
  SearchConversationOnGroup: {},
  AddUserToGroup: {},
  UserLeaveGroup: {},
  Adminaccess: {},
  RemoveGroupAdmin: {},
  UpdateGroupInfo: {},
  DeletedConversation: {},
  chatDeleteMessageRes: {},
  chatWidgetAddUserRes: {},
  addGroupsWidgetResponse: {},
  loginWidgetData: {},
  chatHistoryWidget: {},
};

const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHAT_ROOMS_GET:
      return {
        ...state,
        chatRoomLoading: false,
      };
    case CHAT_ROOMS_SUCCESS:
      return {
        ...state,
        chatRoomLoading: false,
        chatRooms: action.payload,
      };
    case CHAT_ROOMS_FAILED:
      return {
        ...state,
        chatRoomLoading: false,
      };
    case CHAT_CONVERSATION_GET:
      return {
        ...state,
        chatHistoryLoading: true,
        chatHistory: [],
        hasMoreMessages: true,
      };
    case CHAT_CONVERSATION_SUCCESS:
      const data = action.data.data ? action.data.data[0][0].group : [];
      data.sort(function (a, b) {
        return new Date(b.time) - new Date(a.time);
      });
      let tempArray = [];
      const newChatConversations = data.map((chat, index) => {
        const timeStr = chat.time.endsWith("Z") ? chat.time : chat.time + "Z";
        return (chat["time2"] = moment(timeStr).format("MM-DD-YYYY"));
      });

      function groupByTime(time) {
        return data.reduce((acc, obj, i, array) => {
          let objects = {};
          const property = obj[time];
          objects["date"] = property;
          objects["messages"] = [obj];
          if (
            tempArray.find((item, index) => {
              if (item.date == property) {
                tempArray[index].messages.push(obj);
                return true;
              } else {
                return false;
              }
            })
          ) {
            return;
          } else {
            tempArray.push(objects);
          }
        }, {});
      }
      groupByTime("time2");
      return {
        ...state,
        chatHistoryLoading: false,
        chatHistory: tempArray,
        hasMoreMessages: data.length === 10,
      };
    case CHAT_CONVERSATION_LOAD_MORE: {
      const moreData = action.data.data ? action.data.data[0][0].group : [];
      moreData.sort(function (a, b) {
        return new Date(b.time) - new Date(a.time);
      });
      moreData.forEach((chat) => {
        const timeStr = chat.time.endsWith("Z") ? chat.time : chat.time + "Z";
        chat["time2"] = moment(timeStr).format("MM-DD-YYYY");
      });
      // Merge moreData into existing chatHistory (appended at the end since older)
      const mergedHistory = [...state.chatHistory];
      moreData.forEach((msg) => {
        const dateKey = msg["time2"];
        const existingGroup = mergedHistory.find((g) => g.date === dateKey);
        if (existingGroup) {
          // Avoid duplicates
          const alreadyExists = existingGroup.messages.some(
            (m) => m.messageid === msg.messageid
          );
          if (!alreadyExists) {
            existingGroup.messages.push(msg);
          }
        } else {
          mergedHistory.push({ date: dateKey, messages: [msg] });
        }
      });
      // Sort groups by date descending (newest first = top)
      mergedHistory.sort((a, b) => new Date(b.date) - new Date(a.date));
      return {
        ...state,
        chatHistory: mergedHistory,
        hasMoreMessages: moreData.length === 10,
      };
    }
    case CHAT_CONVERSATION_FAILED:
      return {
        ...state,
        chatHistoryLoading: false,
        chatHistory: [],
      };
    case CHAT_CONVERSATION_PUSH_MESSAGE:
      let tempArray2 = [...state.chatHistory];
      let obj = {};
      let newObj;
      let arrayFinal;
      let mainArray = [];
      if (action.payload.deleteMessage === "deleteMessage") {
        tempArray2 = tempArray2.map((msg) => {
          let mainobject = {};
          mainobject["date"] = msg.date;
          arrayFinal = msg.messages.filter((single) => {
            return single.messages !== action.payload.msgs.messages;
          });
          mainobject["messages"] = arrayFinal;
          mainArray.push(mainobject);
        });
        tempArray2 = [...mainArray];

        return {
          ...state,
          chatHistory: tempArray2,
        };
      }
      if (action.payload.offline === "offline") {
        newObj = action.payload.msgs;
        newObj["sendingError"] = "sendingError";
      } else {
        newObj = action.payload;
      }
      newObj["time2"] = moment(newObj.time).format("MM-DD-YYYY");
      obj["date"] = moment(newObj.time).format("MM-DD-YYYY");
      obj["messages"] = [newObj];
      obj["time2"] = moment(newObj.time).format("MM-DD-YYYY");
      if (
        tempArray2.find((item, index) => {
          if (item.date == obj["date"]) {
            tempArray2[index].messages.unshift(newObj);
            return true;
          } else {
            return false;
          }
        })
      ) {
        return {
          ...state,
          chatHistory: tempArray2,
        };
      } else {
        tempArray2.unshift(obj);
        return {
          ...state,
          chatHistory: tempArray2,
        };
      }
    case SEARCH_CONVERSATIONS:
      return {
        ...state,
        searchConversationsResponse: action.data,
      };
    case ADD_INDIVIDUAL_GROUPS:
      return {
        ...state,
        addGroupsResponse: action.data,
      };
    case "EMPTY_INDIVIDUAL_STATE":
      return {
        ...state,
        addGroupsResponse: {},
      };
    // case DELETE_MESSAGE:
    //   let tempArray3 = [...state.chatHistory];
    //   tempArray3 = tempArray3.filter()

    //   return {
    //     ...state,
    //     chatHistory: [...chatHistory],
    //   };
    case CHAT_NEW_ROOM:
      return {
        ...state,
        chatRooms: [action.payload, ...state.chatRooms],
      };
    case GLOBAL_CHAT:
      return {
        ...state,
        globalChatData: action.data,
      };
    case UPDATE_MESSAGE:
      return {
        ...state,
        UpdateMessage: action.data,
      };
    case FATCH_USERS_TO_GROUP:
      return {
        ...state,
        FetchUsersToGroup: action.data,
      };
    case ADD_GROUP:
      return {
        ...state,
        AddGroups: action.data,
      };
    case GROUP_INFO:
      return {
        ...state,
        GroupInfo: action.data,
      };
    case SEARCH_CONVERSATION_GROUP:
      return {
        ...state,
        SearchConversationOnGroup: action.data,
      };
    case ADDUSER_TO_GROUP:
      return {
        ...state,
        AddUserToGroup: action.data,
      };
    case USER_LEAVE_GROUP:
      return {
        ...state,
        UserLeaveGroup: action.data,
      };
    case ADMIN_ACCESS:
      return {
        ...state,
        Adminaccess: action.data,
      };
    case REMOVE_GROUP_ADMIN:
      return {
        ...state,
        RemoveGroupAdmin: action.data,
      };
    case UPDATE_GROUP_INFO:
      return {
        ...state,
        UpdateGroupInfo: action.data,
      };
    case DELETE_CONVERSATION:
      return {
        ...state,
        DeletedConversation: action.data,
      };

    case "CHAT_DELETE_MESSAGE":
      return {
        ...state,
        chatDeleteMessageRes: action.data,
      };

    case CHAT_WIDGET_USER_CREATE:
      return {
        ...state,
        chatWidgetAddUserRes: action.data,
      };
    case ADD_GROUPS_CHAT_WIDGET:
      return {
        ...state,
        addGroupsWidgetResponse: action.data,
      };
    case USER_LOGIN_WIDGET:
      return {
        ...state,
        loginWidgetData: action.data,
      };
    case CHAT_WIDGET_CONVERSATION:
      const data1 = action.data.data ? action.data.data[0][0].group : [];
      data1.sort((a, b) => new Date(b.time) - new Date(a.time));

      const tempArray1 = [];

      data1.forEach((obj) => {
        const date = moment(obj.time2).format("MM-DD-YYYY");
        const existingGroup = tempArray1.find((item) => item.date === date);

        if (existingGroup) {
          existingGroup.messages.push(obj);
        } else {
          tempArray1.push({
            date: date,
            messages: [obj],
          });
        }
      });

      return {
        ...state,
        chatHistoryWidget: tempArray1,
      };

    case CHAT_WIDGET_CONVERSATION_PUSH_MESSAGE:
      const tempArray3 = [...state.chatHistoryWidget];
      const newMessage = action.payload;
      const newMessageDate = moment(newMessage.time).format("MM-DD-YYYY");

      if (action.payload.deleteMessage === "deleteMessage") {
        const filteredArray = tempArray3.map((group) => ({
          date: group.date,
          messages: group.messages.filter((msg) => msg.messages !== action.payload.msgs.messages),
        }));

        return {
          ...state,
          chatHistoryWidget: filteredArray,
        };
      }

      if (action.payload.offline === "offline") {
        newMessage.sendingError = "sendingError";
      }

      const existingGroupIndex = tempArray3.findIndex((group) => group.date === newMessageDate);

      if (existingGroupIndex !== -1) {
        const existingMessages = tempArray3[existingGroupIndex].messages;

        // Check if a message with the same time already exists
        const duplicateMessage = existingMessages.find(
          (msg) => msg.time === newMessage.time && msg.senderid === newMessage.senderid
        );

        // If no duplicate is found, add the new message
        if (!duplicateMessage) {
          tempArray3[existingGroupIndex].messages.unshift(newMessage);
        }
      } else {
        // If no group exists for the date, add the new message as a new group
        tempArray3.unshift({
          date: newMessageDate,
          messages: [newMessage],
        });
      }

      return {
        ...state,
        chatHistoryWidget: tempArray3,
      };

    case ADD_USER_TO_GROUP_CHAT_WIDGET:
      return {
        ...state,
        AddUserToGroup: action.data,
      };
    case "EMPTY_GROUP_STATE":
      return {
        ...state,
        UserLeaveGroup: {},
      };
    default:
      return state;
  }
};

export default chatReducer;
